import { useQuery } from '@tanstack/react-query';

import { gamesQueryKey } from '@/api/queryKeys';
import { api } from '@/lib/api-client';
import type { Game } from '@/models/game';
import type { PaginationResponse } from '@/models/pagination';

export const getGames = async () => {
  // Every reachable Game in one page: routes resolve a Game against this list,
  // and admin-api pages by 10 unless told otherwise. 200 is its clamp.
  // ponytail: one page; page through it if a viewer ever reaches 200 Games.
  const response = await api.get<{ games: Game[] } & PaginationResponse>(
    `/v1/games`,
    { params: { limit: 200 } },
  );
  return response.data;
};

export const getGamesQueryOptions = () => {
  return {
    queryKey: gamesQueryKey.all,
    queryFn: getGames,
  };
};

export const useGetGames = () => {
  return useQuery(getGamesQueryOptions());
};

export const useGetGame = (game_code: string) => {
  return useQuery({
    ...getGamesQueryOptions(),
    select: ({ games }: { games: Game[] }) => {
      return games.find((g) => g.game_code === game_code);
    },
  });
};
